import Cookies from "js-cookie"

import type { Nullable } from "@bounce/util"

import { config } from "@/config"

type SetCookieOptions = Omit<Cookies.CookieAttributes, "domain"> & {
  key: string
  value: string
  domain?: Nullable<string>
}

export const setCookie = ({ key, value, domain = config.cookieDomain, ...options }: SetCookieOptions) =>
  Cookies.set(key, value, {
    sameSite: "strict",
    strict: window.location.protocol === "https:",
    domain: domain ?? undefined,
    ...options,
  })
